var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{staticClass:"mb-15",attrs:{"show-arrows":false}},[_c('v-carousel-item',{attrs:{"cover":""}},[_c('v-img',{attrs:{"src":require("../csv.jpg")}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }